import * as React from 'react';
import c from 'classnames';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import { CoreLink } from '@uncinc/react-drupal-core';

type Props = {
  title: string,
  link: string,
  titleClassName?: string,
  onClick?: React.MouseEventHandler<any>;
  as?: keyof JSX.IntrinsicElements;
};

const LinkListSecondaryItem: React.FC<Props> = (props) => {
  const {
    title,
    link,
    titleClassName,
    onClick,
    as: Component = 'li',
  } = props;

  const titleClasses = c('LinkList__SecondaryItem__title', titleClassName);
  const classes = c('LinkList__SecondaryItem', 'u-link-box');

  return (
    <Component className={classes}>
      <div className="LinkList__SecondaryItem__content">
        <h4 className={titleClasses}>
          <CoreLink
            to={link}
            title={title}
            onClick={(e: React.MouseEvent<any, MouseEvent>) => {
              if (onClick) {
                onClick(e);
              }
            }}
          />
        </h4>
      </div>
      <Icon name="chevron_right" />
    </Component>
  );
};

export default LinkListSecondaryItem;
